export default __webpack_public_path__ + "static/media/NotificationBellIcon.3db4748c.svg";